import { render, staticRenderFns } from "./FAQMostActiveOffersComponent.vue?vue&type=template&id=d1b46c36&scoped=true&"
import script from "./FAQMostActiveOffersComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQMostActiveOffersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQMostActiveOffersComponent.vue?vue&type=style&index=0&id=d1b46c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b46c36",
  null
  
)

export default component.exports